var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-date-picker",
    attrs: {
      owner: _vm._self,
      "block-class": { "ds-error-border": _vm.errors.length > 0 },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "simple",
          fn: function () {
            return [
              _c(
                "span",
                {
                  attrs: {
                    title: _vm._f("proxy")(_vm.getShowContent(), _vm.formatter),
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm._f("proxy")(_vm.getShowContent(), _vm.formatter))
                  ),
                ]
              ),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              !_vm.readOnly
                ? _c("ds-date-picker", {
                    attrs: {
                      type: _vm.pickerType,
                      "period-type": _vm.chooseType,
                      format: _vm.format,
                      "value-format": _vm.valueFormat,
                      "picker-options": _vm.mPicker || _vm.pickerOptions,
                      disabled: _vm.disabled,
                      clearable: _vm.clearable,
                      popperClass: "ds-date-picker-panel",
                      "default-time": ["00:00:00", "23:59:59"],
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                    },
                    model: {
                      value: _vm.value2,
                      callback: function ($$v) {
                        _vm.value2 = $$v
                      },
                      expression: "value2",
                    },
                  })
                : _vm.readOnly
                ? _c("div", { staticClass: "ds-form-readonly" }, [
                    _c(
                      "span",
                      {
                        attrs: {
                          title: _vm._f("proxy")(
                            _vm.getShowContent(),
                            _vm.formatter
                          ),
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("proxy")(_vm.getShowContent(), _vm.formatter)
                          )
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }